import { render } from "./AppNotification.vue?vue&type=template&id=7ea87ad2"
import script from "./AppNotification.vue?vue&type=script&lang=js"
export * from "./AppNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__